export const TOKEN_STORAGE_KEY = "PennToken";
export const USER_STORAGE_KEY = "PennUser";
